import {getAuth, onIdTokenChanged} from "firebase/auth";
import {getFirebaseAuth} from "@/lib/firebase/client-app";

let _initialize: Promise<void> | null = null;

export function idTokenReady(): Promise<void> {
    if (!_initialize) {
        // run the app init if you haven’t yet
        getFirebaseAuth();
        _initialize = new Promise((resolve) => {
            const unsubscribe = onIdTokenChanged(getAuth(), () => {
                unsubscribe();
                resolve();
            });
        });
    }
    return _initialize;
}